import { typographyDefinition } from "@huub-web/ui/theme/typography";
import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";

import { carouselStyle } from "@huub-web/ui/components/Carousel/Carousel.css";
import { theme } from "@huub-web/ui/theme/css/theme.css";

export const imageContainerStyle = style({
  flexGrow: 0,
});

export const imageStyle = style({
  width: rem(100),
  aspectRatio: "4/3",
});

export const tipRowStyle = style({
  gap: theme.spacings.s,
  alignItems: "flex-start",
  ...typographyDefinition.bodyS,
});

export const carouselImageStyle = style({
  selectors: {
    [`${carouselStyle} &`]: {
      width: rem(120),
    },
  },
});

export const containerStyle = recipe({
  base: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacings.s,
    padding: theme.spacings.s,
    borderRadius: theme.borderRadiuses.onS,
  },
  variants: {
    alternate: {
      true: {
        backgroundColor: theme.colors.backgroundTint,
      },
    },
  },
  defaultVariants: {
    alternate: false,
  },
});
